import TableCell, { TableCellProps } from '../TableCell/TableCell';

const EmptyCell = (props: TableCellProps) => (
  <TableCell {...props}>-</TableCell>
);

export default EmptyCell;
